import { Grid } from '@mui/material';
import React from 'react';

import SearchBar from 'components/atoms/SearchBar';

interface LabsSearchProps {
  labSearchText: string;
  onClearSearch: () => void;
  onSearchChange: (value: string) => void;
}

export const LabsSearch: React.FC<LabsSearchProps> = ({ labSearchText, onClearSearch, onSearchChange }) => {
  return (
    <Grid item>
      <SearchBar
        fullWidth
        size="small"
        placeholder="Search by lab name or ID"
        clearAriaLabel="Clear lab search"
        value={labSearchText}
        onChange={onSearchChange}
        inputProps={{ 'aria-label': 'Search labs' }}
        sx={{
          maxWidth: 440,
        }}
        onKeyDown={(event) => {
          if (!event.defaultPrevented && event.key === 'Escape' && !labSearchText) {
            onClearSearch();
          }
        }}
        data-testid="lab-search-input"
      />
    </Grid>
  );
};
